var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e()]), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "income-methodology-note"
  }, [_vm._v(" Dôchodok sa uloží ako doplnkový príjem. Jeho akceptovanú výšku vypočítame pre každú banku samostatne. ")]), _c('div', {
    staticClass: "dropdown-input-custom rest-input",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'retirement_druh',
      "init-value": _vm.form.druh,
      "options": _vm.druhChoices,
      "normal": "",
      "name": 'Typ dôchodku'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'druh');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.suma,
      expression: "form.suma",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "name": "vyska-dochodok",
      "data-name": "vyska-dochodok",
      "required": "",
      "id": "vyska-dochodok"
    },
    domProps: {
      "value": _vm.form.suma
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "suma", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.isInvalidPension ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "invalidity-percent"
    }
  }, [_vm._v(" Pokles schopnosti pracovať v percentách ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.invalidityPercent,
      expression: "form.invalidityPercent",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "max": "100",
      "name": "invalidity-percent",
      "required": "",
      "id": "invalidity-percent"
    },
    domProps: {
      "value": _vm.form.invalidityPercent
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "invalidityPercent", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('small', {
    staticClass: "field-help"
  }, [_vm._v("Údaj je potrebný na presné posúdenie invalidného dôchodku v UniCredit Bank.")])]) : _vm._e()])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vyska-dochodok"
    }
  }, [_vm._v("Výška dôchodku"), _c('strong')]);

}]

export { render, staticRenderFns }